/**
 * @author zhouchangluan
 * @fileoverview 基础工具函数
 */

/**
 * 空函数
 */
export function noop() {}

/**
 * 判断值是否为空
 * @param {any} val 判断的值
 */
export function isEmpty(val) {
  if (val === null || val === undefined || val === "") {
    return true;
  } else {
    return false;
  }
}

/**
 * 如果值为空，则转换为替换的值，否则不转换
 * @param {any} val 判断是否为空的值
 * @param {any} replace 要替换的值
 */
export function replaceEmpty(val, replace = "-") {
  if (isEmpty(val)) {
    return replace;
  } else {
    return val;
  }
}

// 判断是否是移动端
export function isMobile() {
  if (window.innerWidth < 1200) {
    // 当前设备是移动设备
    return true;
  } else {
    return false;
  }
}

/**
 * 获取签名key
 */
export function getSignKey(url) {
  if (url.includes(process.env.VUE_APP_BASEURL)) {
    return process.env.VUE_APP_BASEURL_SIGN_KEY;
  }
  if (url.includes(process.env.VUE_APP_ACTIVE_BASEURL)) {
    return process.env.VUE_APP_ACTIVE_BASEURL_SIGN_KEY;
  }
  return "";
}

/**
 * 时间格式化
 * @param date 时间
 * @param fmt 时间格式，默认YYYY-MM-DD HH:mm:ss
 */
export const dateFormat = (date, fmt= 'YYYY-MM-DD HH:mm:ss') => {
  let ret;
  const opt = {
    'Y+': date.getFullYear().toString(), // 年
    'M+': (date.getMonth() + 1).toString(), // 月
    'D+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'm+': date.getMinutes().toString(), // 分
    's+': date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  let newfmt = fmt;
  Object.keys(opt).forEach((k) => {
    ret = new RegExp(`(${k})`).exec(fmt);
    if (ret) {
      newfmt = newfmt.replace(
        ret[1],
        ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'),
      );
    }
  });
  return newfmt;
};
